import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const STYLESHEET_CONTEXT_SYMBOL = Symbol();
const useStylesheet = ()=>useImmutableContext(STYLESHEET_CONTEXT_SYMBOL);
const useStylesheetProvider = (...args)=>useImmutableContextProvider(STYLESHEET_CONTEXT_SYMBOL, ...args);
export { useStylesheet, useStylesheetProvider };
